export const loginTypeConstants = {
  TOTAL_LOGIN: 'totalLogin',
  AUTO_LOGIN: 'autoLogin',
};

export const LOGIN_FLOW_QUERY = {
  KEY: 'fromLogin',
  VALUE: 'true',
} as const;
